import { ISourceTokenDebugger, ITokenDebugger } from './authTokenTypes';

export class NoOpSourceTokenDebugger implements ISourceTokenDebugger {
  constructor() {}

  addEvent(): void {
    // Do nothing
  }
}

export class NoOpTokenDebugger implements ITokenDebugger {
  sourceTokenDebugger = new NoOpSourceTokenDebugger();

  addEvent(): void {
    // Do nothing
  }

  addGlobalEvent(): void {
    // Do nothing;
  }

  forSource(): ISourceTokenDebugger {
    return this.sourceTokenDebugger;
  }
}
